module.exports = __webpack_public_path__ + "img/khlogo.40edccd9.svg";